import "./id-link-cell.css";

import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import type { ReactNode } from "react";
import { Link } from "react-router";

type IdLinkCellProps<T> = Omit<GridCustomCellProps, "dataItem"> & {
	dataItem: T;
	linkTo: string | { pathname: string };
	isDisabled?: boolean;
	displayText: string | ReactNode;
	className?: string;
	onClick?: () => void;
};

export const IdLinkCell = <T,>(props: IdLinkCellProps<T>) => {
	const { linkTo, displayText, className, onClick, ...gridProps } = props;

	return (
		<td {...gridProps.tdProps}>
			{props.isDisabled ? (
				<span className={`id-link ${className ?? ""}`}>{displayText}</span>
			) : (
				<Link className={`id-link ${className}`} onClick={onClick} to={linkTo}>
					{displayText}
				</Link>
			)}
		</td>
	);
};
